import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../../../core/authentication';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { HostListener } from '@angular/core';
import { ServiceProvider } from '../../../../core/service/service.provider';
import { LocalStorageService } from '../../../local-storage.service'
import { NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-top-menu-bar',
  templateUrl: './top-menu-bar.component.html',
  styleUrls: ['./top-menu-bar.component.scss']
})
export class TopMenuBarComponent implements OnInit {

  loading = false;
  submitted = false;
  isNavbarCollapsed = true;
  collapsed = true;
  roleName;
  roles;
  modalReference;
  closeResult;
  changePasswordForm;
  roleChangeForm;
  userName;
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private toastr: ToastrService,public dataService: ServiceProvider,
    private storage: LocalStorageService,
    private modalService: NgbModal, private fb: FormBuilder
  ) { }

  ngOnInit() {
      this.getUserProfile()
  }

  getUserProfile(){
    this.dataService.get('GetUserProfile').subscribe((values) => {
      this.roleName = values.role_data.role_name;
      this.userName = values.user_name;
      this.roles = this.storage.getData("roles")
      this.storage.setData("userData", values);
      this.storage.setData("isRoleChange", "true")
    }, (err) => {
        if (Array.isArray(err.error) || typeof err.error == 'object') {
            for (let er in err.error) {
                this.toastr.error(er + ' - ' + this.formErrValue(err.error[er]), 'Failed');
            }
        } else {
            this.toastr.error(err.error, 'Failed');
        }
    });
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    const element = document.querySelector('.navbar');
    // if (window.pageYOffset > element.clientHeight) {
    if (window.pageYOffset > 5) {
      element.classList.add('navbar-inverse');
    } else {
      element.classList.remove('navbar-inverse');
    }
  }
  logout(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg', windowClass: 'project-status-modal', backdrop : 'static', keyboard : false}).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
      this.submitted = true;
      this.loading = true;
      this.dataService.get('logout').subscribe(data => {
        this.toastr.success('Logged out successfully', 'Success');
        this.storage.clearData()
        this.router.navigate(['/login']);
      }, (err) => {
        this.toastr.error('Have issue with logout!', 'Failed');
      });
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
    
  }
  
    changePassword(content) {
      this.changePasswordForm = this.fb.group({
        old_password: ['', Validators.required],
        new_password: ['', Validators.required],
        confirm_password: ['', Validators.required],
      });
      this.modalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg', windowClass: 'project-modal-xs', backdrop : 'static', keyboard : false})
      this.modalReference.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
        
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.paswdformValuesReset()
      });
    }

    changeRole(content) {
      let role_data = this.storage.getData("userRole")
      this.roleChangeForm = this.fb.group({
        selectedrole: [role_data.id, Validators.required]
      });
      // this.roleChangeForm.patchValue({selectedrole: role_data});
      this.modalReference = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg', windowClass: 'project-modal-xs', backdrop : 'static', keyboard : false})
      this.modalReference.result.then((result) => {
        this.closeResult = `Closed with: ${result}`;
        
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        this.roleformValuesReset()
      });
    }

    updateRole(){
      let role_data = this.roles.find(data => data.id == this.roleChangeForm.value['selectedrole'])
      this.storage.setData("userRole", role_data);
      this.toastr.success("Role changes successfully." , 'Success');
      this.modalReference.close()
      this.router.navigate(['/dashboard']);
      this.roleformValuesReset()
      this.getUserProfile()
    }

    updatePassword(){
      this.changePasswordForm.value['user'] = this.storage.getData("userData")['id']
      this.dataService.post('ChangePassword', null, this.changePasswordForm.value)
      .subscribe((type) => {
      this.toastr.success("Password updated successfully. Kindly login again." , 'Success');
      this.modalReference.close()
      this.paswdformValuesReset()
      this.storage.clearData()
      this.router.navigate(['/login'])
    }, (err) => {
      if(Array.isArray(err)){
        for(let er in err){
          this.toastr.error(er + ' - '+this.formErrValue(err[er]) ,'Failed');
        }
      }else{
        this.toastr.error(err.error ,'Failed');
      }
    });
    }

    paswdformValuesReset(){
      this.changePasswordForm.reset()
    }

    roleformValuesReset(){
      this.roleChangeForm.reset()
    }
  
    private getDismissReason(reason: any): string {
      if (reason === ModalDismissReasons.ESC) {
        return 'by pressing ESC';
      } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
        return 'by clicking on a backdrop';
      } else {
        return  `with: ${reason}`;
      }
    }

    formErrValue(er) {
        if (Array.isArray(er)) {
            return er.join(', ')
        } else {
            return er
        }
    }
}
